module.exports = __webpack_public_path__ + "img/mucousmembrane.4f79f3ae.gif";